import { useMediaQuery, useTheme } from '@material-ui/core';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import MenuLogo from 'src/features/drawer/MenuLogo';
import { SettingsSidebarBackToggle } from 'src/legacy/components/Sidebar/SettingsSidebarBackToggle';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';

const useStyles = makeStyles()((theme) => ({
  settingsHeaderTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
}));

interface SettingsPageHeaderTitleProps {
  /** Show the mobile hamburger menu inside this header. Only needed when the
   *  component is rendered as the AppBar header slot (via PageShell), because
   *  it replaces NavbarContent which normally provides the hamburger.
   *  When rendered as a `title` inside FormPageHeaderBase, that component
   *  already supplies its own MenuLogo. */
  showMenu?: boolean;
}

export const SettingsPageHeaderTitle: React.FC<
  SettingsPageHeaderTitleProps
> = ({ showMenu = false }) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return isSmScreen ? (
    <div className={classes.settingsHeaderTitleWrapper}>
      {showMenu && <MenuLogo />}
      <SettingsSidebarBackToggle />

      <BaseTypography fontType="15Medium">Settings</BaseTypography>
    </div>
  ) : null;
};
